import React from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
import { IMAGE_SIZES, ResponsiveImage } from '@web/molecules/ResponsiveImage';
import { MuxVideo } from '@web/components/MuxVideo';
import {
  MediaCellWrapper,
  MediaCellMobile,
  MediaCellDesktop,
} from './styles.js';

export const MediaCell = ({
  mobileAsset,
  desktopAsset,
  roundedAsset = false,
}) => {
  return (
    <MediaCellWrapper $rounded={roundedAsset}>
      <MediaCellMobile>
        {mobileAsset?.component === 'mux_video' ? (
          <MuxVideo {...mobileAsset} />
        ) : (
          <ResponsiveImage
            {...mobileAsset}
            style={{ width: '100%', height: 'auto' }}
            sizes={IMAGE_SIZES.halfAtLaptop}
          />
        )}
      </MediaCellMobile>
      <MediaCellDesktop>
        {desktopAsset?.component === 'mux_video' ? (
          <MuxVideo {...desktopAsset} />
        ) : (
          <ResponsiveImage
            {...desktopAsset}
            {...omit(desktopAsset, ['width', 'height'])}
            sizes={IMAGE_SIZES.halfAtLaptop}
          />
        )}
      </MediaCellDesktop>
    </MediaCellWrapper>
  );
};

MediaCell.displayName = 'MediaCell';

MediaCell.propTypes = {
  mobileAsset: PropTypes.object.isRequired,
  desktopAsset: PropTypes.object.isRequired,
  roundedAsset: PropTypes.bool,
};
